module.exports = __webpack_public_path__ + "static/media/S46.2aa66303.png";